import React from 'react';
import ReactDOM from 'react-dom';
import CalculatorInput from 'CalculatorInput';
import { Desktop, LargeMobile } from 'Responsive';
import { formatNumber } from 'Utils';

export default class LoanRepaymentCalculator extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <LoanRepaymentCalculator {...props} />,
      document.getElementById(id),
    );
  }

  static renderDetails() {
    return (
      <div className="loan-repayment-calculator-description">
        <h2>Loan Repayment Calculator</h2>
        <h4>Methodology</h4>
        <p>
          The Loan Repayment Calculator was created to help you determine how
          much you will pay in total for a loan. Input the original loan
          amount, the repayment terms in months, and the monthly interest,
          to determine the total interest you will pay on the loan over the
          loan period, and the total repayment including that interest.
        </p>
      </div>
    );
  }


  constructor() {
    super();
    this.state = {
      loanAmount: '0',
      repaymentTerm: '0',
      interestPercent: '0',
      totalInterestResult: '0',
      totalRepaymentResult: '0',
    };
    this.calculateResults = this.calculateResults.bind(this);
  }

  calculateResults() {
    let totalInterest = 0;
    let totalRepayment = 0;
    let currentBalance = +this.state.loanAmount;
    const principal = currentBalance / (+this.state.repaymentTerm);

    for (let i = 0; i < +this.state.repaymentTerm; i += 1) {
      const interestDecimal = (+this.state.interestPercent / 100);
      const currentInterest = currentBalance * (interestDecimal / +this.state.repaymentTerm);
      const currentPayment = principal + currentInterest;

      currentBalance -= principal;
      totalInterest += currentInterest;
      totalRepayment += +currentPayment;
    }

    this.setState({
      totalInterestResult: formatNumber(totalInterest.toFixed(2)),
      totalRepaymentResult: formatNumber(totalRepayment.toFixed(2)),
    });
  }

  render() {
    return (
      <div className="container loan-repayment-calculator-container">
        <div className="row">
          <div className="col-xs-12 col-md-2 col-md-offset-1 loan-repayment-calculator-inputs">
            <LargeMobile>
              {LoanRepaymentCalculator.renderDetails()}
            </LargeMobile>
            <CalculatorInput
              title="LOAN AMOUNT"
              value={this.state.loanAmount}
              onChange={loanAmount => this.setState({ loanAmount })}
              type="monetary"
            />
            <CalculatorInput
              title="REPAYMENT TERM (MONTHS)"
              value={this.state.repaymentTerm}
              onChange={repaymentTerm => this.setState({ repaymentTerm })}
            />
            <CalculatorInput
              title="INTEREST (MONTHLY)"
              value={this.state.interestPercent}
              onChange={interestPercent => this.setState({ interestPercent })}
              type="percent"
            />
            <span className="divider" />
            <button onClick={this.calculateResults}> Calculate </button>
          </div>
          <div className="col-xs-12 col-md-7 col-md-offset-1 loan-repayment-calculator-right-col">
            <Desktop>
              {LoanRepaymentCalculator.renderDetails()}
            </Desktop>
            <div className="loan-repayment-calculator-results-container">
              <div className="caret" />
              <div className="loan-repayment-calculator-results-wrapper">
                <div className="loan-repayment-calculator-results">
                  <CalculatorInput
                    title="TOTAL INTEREST"
                    value={this.state.totalInterestResult}
                    type="monetary"
                    disabled
                  />
                </div>
                <div className="loan-repayment-calculator-results">
                  <CalculatorInput
                    title="TOTAL REPAYMENT"
                    value={this.state.totalRepaymentResult}
                    type="monetary"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src-react/LoanRepaymentCalculator/index.jsx